/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Sidebar} from "primereact/sidebar";
import constantes from "../../catalogos/constantes";
import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import Form from "../../shared/forms/Form";
import moment from "moment";
import FormTabView from "../../shared/forms/Tabs/FormTabView";
import General from "./Edicion/general";
import Cargos from "./Edicion/cargos";
import Movimientos from "./Edicion/movimientos";
import {Button} from "primereact/button";
import {serialize} from "object-to-formdata";
import useApiIncidencia from "../../api/administracion/useApiIncidencia";
import useSeguridad from "../../Seguridad/useSeguridad";
import Documentos from "./Edicion/documentos";
import alerts from "../../shared/alerts";
import Historial from "./Edicion/historial";
import Desgloce from "./Edicion/desgloce";
import YupValidator from "../../shared/YupValidator";
import incidenciaValidacionEsquema from "./incidenciaValidacionEsquema";
const IncidenciaDetalle =  React.memo( ({incidenciaId, onCancel, onSaved, puedeEditar, onRefresh, empleado, viaje,esSeguimientoMonitoreo}) => {
    const [gestorGuardadoId, setGestorGuardadoId] = useState(null)


    const initialValues = {
        incidencia: {
            id: 0,
            fechaIncidencia: moment().startOf('day')._d,
            solicitante: {
                id: empleado?.id,
                nombre: empleado?.nombre
            },
            tieneReporteAseguradora:false,
            seUsoGrua:false,
            reporteAseguradora:null
        }
    };
    
    const visible = incidenciaId !== null;    
    const validador = new YupValidator(incidenciaValidacionEsquema);
    const [submitted, setSubmitted] = useState(false);
    const {
        values: item,
        setValues,
        onChange,
        onValidate,
        errors
    } = useForm(initialValues);   
    const api = useApiIncidencia();
    const seguridad = useSeguridad();
    const permisoEstatusIncidencia = seguridad.tieneAcceso(constantes.opciones.permisoEstatusIncidencia)

    const onLoad = async (viaje) => {
        if (viaje != null){
            const datos = await api.obtenerPorViajeId({viajeId: viaje.id, unidadId: viaje.unidad?.id,esSeguimientoMonitoreo});
            setValues({...initialValues, incidencia: datos});
            return;
        }


        if (incidenciaId === 0 || incidenciaId === null) {
            setValues(initialValues);
            return;
        }

        let result = await api.obtener(incidenciaId);

        result.saldoAnterior = result.saldo;
        const item = {
            incidencia: result
        };
        setValues(item);
        setGestorGuardadoId(result.gestorOperacionesId);
    };

    useEffect(() => {
        onLoad(viaje).then();
    }, [incidenciaId, viaje]);



    const onSave = async () => {
        setSubmitted(true);
        if (await validador.validate(item.incidencia) === false) {
            console.log(validador.errors);
            return;
        }

        const formData = serialize(item?.incidencia ?? {}, {indices: true, dotsForObjectNotation: true});
        await api.guardar(formData);
        onSaved();
    }

    const actualizarEstatus = async (estatusId) => {
        const msg = estatusId === constantes.estatusIncidencias.Cancelada ? '¿Desea cancelar la incidencia?' : '¿Desea cerrar la incidencia?';
        if ((await alerts.preguntarSiNo(msg)) === true) {
            const formData = serialize({estatus: estatusId}, {indices: true, dotsForObjectNotation: true});
            await api.actualizarEstatus(item.incidencia.id, formData);
            onSaved();
        }
    };

    const Cerrar = async () => {
        if ((await alerts.preguntarSiNo("¿Desea cerrar la incidencia?")) === true) {

            const formData = serialize(item.incidencia ?? {}, {indices: true, dotsForObjectNotation: true});
            await api.cerrar(formData);
            onSaved();
        }
    };
    const CambiarEstatus = async()=>{
        if ((await alerts.preguntarSiNo("¿Desea cambiar el estatus a Sin Cargo?")) === true) {

            const formData = serialize(item.incidencia ?? {}, {indices: true, dotsForObjectNotation: true});
            await api.cambiarEstatus(formData);
            onSaved();
        }
    }
    return (
        <>
            <Sidebar visible={visible} position="right" dismissable={false}
                     className="p-sidebar-xl"  onHide={onCancel}>
                <Form columns={1} values={item} onChange={onChange}
                      onValidate={onValidate} submitted={submitted} formDisabled={item?.incidencia?.id > 0}
                      className={`form-container full-height ${submitted ? 'submitted' : ''}`}>
                    <FormTabView>
                        <Field title="General" field={'incidencia'}
                               render={(props) => <General {...props} gestorGuardadoId={gestorGuardadoId} puedeEditar={puedeEditar} errors={errors} submitted={submitted}/>}/>
                        {item?.incidencia?.id > 0 &&
                            <Field title="Cargos" field={'incidencia'}
                                   render={(props) => <Cargos {...props} puedeEditar={puedeEditar}
                                                              onRefresh={onRefresh} onSaved={onSave}/>}/>
                        }
                        {item?.incidencia?.id > 0 && item?.incidencia?.cobro &&
                            <Field title="Movimientos" field={'incidencia'}
                                   render={(props) => <Movimientos {...props} puedeEditar={false}
                                                              onRefresh={onRefresh}/>}/>
                        }
                        {item?.incidencia?.id > 0 && item?.incidencia?.cobro &&
                            <Field title="Desgloce" field={'incidencia'}
                                   render={(props) => <Desgloce {...props} puedeEditar={false}
                                                              onRefresh={onRefresh}/>}/>
                        }
                        {item?.incidencia?.id > 0 && item?.incidencia?.cobro &&
                            <Field title="Historial" field={'incidencia'}
                                   render={(props) => <Historial {...props} puedeEditar={false}
                                                              onRefresh={onRefresh}/>}/>
                        }                        
                        <Field title="Documentos" 
                                field={'incidencia'}
                                render={({ onChange, ...props }) => (
                                    <Documentos {...props} onChange={onChange} errors={errors} />
                                )}
                            />
                        
                
                    </FormTabView>
                </Form>
                <div className="form-footer">
                    <Button label="Salir" onClick={onCancel} className="p-button-outlined"/>
                    {item?.incidencia?.cargos?.length > 0 && (item?.incidencia?.saldo === 0 || item?.incidencia?.saldo < 0) && item?.incidencia?.estatus === constantes.estatusIncidencias.EnProceso &&
                        <>
                            <Button label="Cancelar" type="button" className="p-button-warning"
                                    onClick={() => actualizarEstatus(constantes.estatusIncidencias.Cancelada)}/>
                            <Button label="Cerrar" type="button"
                                    onClick={() => actualizarEstatus(constantes.estatusIncidencias.Cerrada)}/>
                        </>
                    }
                    {(item?.incidencia?.id === 0 || (item?.incidencia?.estatus === constantes.estatusIncidencias.SinCargo || item?.incidencia?.estatus === constantes.estatusIncidencias.PendienteCobro )) &&
                        <Button label="Guardar" type="button"
                                onClick={onSave}/>
                    }

                    {item?.incidencia?.id > 0 && item?.incidencia?.estatus === constantes.estatusIncidencias.SinCargo &&
                        <Button label="Cerrar" type="button"
                                onClick={Cerrar}/>
                    }
                    {(item?.incidencia?.estatus === constantes.estatusIncidencias.Cerrada || item?.incidencia?.estatus === constantes.estatusIncidencias.SinCobro || item?.incidencia?.estatus === constantes.estatusIncidencias.ProcesoCobro|| item?.incidencia?.estatus === constantes.estatusIncidencias.PendienteCobro ) && permisoEstatusIncidencia &&
                        <Button label="Cambiar Estatus" type="button"
                                onClick={CambiarEstatus}/>
                    }
                    {/* {(item?.incidencia?.estatus === constantes.estatusIncidencias.PendienteCobro || item?.incidencia?.estatus === constantes.estatusIncidencias.ProcesoCobro )&& item?.incidencia?.movimientos?.filter(c => c.saldoActual===0).length > 0  &&
                        <Button label="Cobrar" type="button" onClick={onConfirm}/>
                    } */}
                </div>
            </Sidebar>
            {/* <Cobro visible={cobrar} onClose={() => setCobrar(false)} incidencia={item?.incidencia}
                   onSaved={() => {
                       onSaved();
                       setCobrar(false);
                   }}/> */}
        
        </>
    );
});

export default IncidenciaDetalle;
